<template>
  <div class="achievement-top-bar">
    <!-- 第一行-查询条件 -->
    <!-- 查询条件 -->
    <div class="select">
      <!-- 年级 -->
      <div class="select-item">
        <el-select v-model="searchInfo.gradeId" placeholder="选择年级">
          <el-option :label="item.gradeName" :value="item.gradeId" v-for="item in gradeList"
            :key="item.gradeId"></el-option>
        </el-select>
      </div>
      <div class="select-item">
        <!-- <el-date-picker v-model="searchInfo.schoolYear" type="year" placeholder="选择学年" value-format="yyyy">
        </el-date-picker> -->
        <year-range-picker style="width: 250px;" v-model="searchInfo.schoolYear" />
      </div>
      <div class="select-item">
        <el-select v-model="searchInfo.semester" placeholder="选择学期" clearable>
          <el-option v-for="item in semesterOptions" :key="item.dictValue" :label="item.dictLabel"
            :value="item.dictValue">
          </el-option>
        </el-select>
      </div>
      <!-- 标题 -->
      <div class="select-item">
        <el-select v-model="searchInfo.title" placeholder="选择考试主标题" filterable allow-create default-first-option>
          <el-option :label="item" :value="item" v-for="(item, index) in examTitleList" :key="index"></el-option>
        </el-select>
      </div>
      <div class="select-item">
        <el-input v-model="searchInfo.subTitle" placeholder="请输入考试副标题"></el-input>
      </div>
      <!-- 时间 -->
      <div class="select-item">
        <el-date-picker type="date" placeholder="选择考试时间" v-model="searchInfo.startTime" value-format="yyyy-MM-dd"
          style="width: 100%"></el-date-picker>
      </div>
      <div class="select-btn">
        <!-- 搜索 -->
        <el-button class="btn-color-1 same" @click="search">
          <i class="iconfont icon-search" />
          搜索
        </el-button>
        <!-- 重置 -->
        <el-button class="reset same" @click="reset" icon="el-icon-refresh">重置</el-button>
      </div>
    </div>
    <!-- 按钮列表 -->
    <div class="btn-list">
      <!-- 创建考试 -->
      <el-button class="same" @click="createExam" v-hasPermi="'sc:examinfo:add'" type="success">创建考试</el-button>
      <!-- 修改考试 -->
      <el-button class="same" @click="editExam" v-hasPermi="'sc:examinfo:edit'" type="warning">修改考试</el-button>
      <!-- 删除考试 -->
      <el-button class="btn-color-2 same" @click="deleteGradeClick" v-hasPermi="'sc:examinfo:delete'">
        删除考试
      </el-button>
      <!-- 学生成绩对比 -->
      <el-button v-hasPermi="'sc:gradescore:comparison'" type="warning" class="same" @click="gradeComparison">
        学生成绩对比
      </el-button>
      <!-- 考试名次对比 -->
      <el-button v-hasPermi="'sc:gradescore:comparison'" type="warning" class="same" @click="examRankComparison">
        考试名次对比
      </el-button>
      <!-- 校外成绩对比 -->
      <el-button v-hasPermi="'sc:gradescore:comparison'" type="warning" class="same"
        @click="externalPerformanceComparison">
        校外成绩对比
      </el-button>
      <!-- 校外成绩录入 -->
      <el-button class="btn-color-1 same" @click="externalScoreEntry" v-hasPermi="'sc:externalachievement:edit'">
        校外成绩录入
      </el-button>
      <!-- 分制录入 -->
      <el-button class="btn-color-1 same" @click="pointSystemEntry" v-hasPermi="'sc:coursefull:edit'">
        分制录入
      </el-button>
      <!-- 指标录入 -->
      <el-button class="btn-color-1 same" @click="scoreIndexEntry" v-hasPermi="'sc:coursegrade:edit'">
        指标录入
      </el-button>
      <!-- 成绩录入 -->
      <el-button class="btn-color-1 same" @click="scoreEntry" v-hasPermi="'sc:score:add'">成绩录入</el-button>
      <!-- 成绩分析 -->
      <!-- <el-button class="btn-color-1 same" @click="scoreAnalyze">成绩分析</el-button> -->
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "schoolYear",
    "semester",
    "semesterOptions",
    "gradeList",
    "examTitleList",
  ], // 学年，学期， 学期数据列表，年级列表, 考试主标题列表
  data() {
    return {
      // 搜索条件
      searchInfo: {
        title: "", // 主标题
        subTitle: "", // 副标题
        startTime: "", // 考试时间
        gradeId: "", // 年级
        semester: "", // 学期
        schoolYear: "", // 学年
      },
    };
  },
  created() { },
  mounted() {
    // 初始赋值个人信息中的学年学期
    // setTimeout(() => {
    //   this.searchInfo.semester = this.semester;
    //   this.searchInfo.schoolYear = this.schoolYear;
    // }, 300);
  },
  methods: {
    // 点击搜索
    search() {
      // console.log("searchInfo:", this.searchInfo);
      this.$emit("gradeExamSearch", this.searchInfo);
    },
    // 点击重置
    reset() {
      this.searchInfo = {
        title: "", // 主标题
        subTitle: "", // 副标题
        startTime: "", // 考试时间
        gradeId: "", // 年级
        semester: "", // 学期
        schoolYear: "", // 学年
      };
      this.$emit("gradeExamSearch", this.searchInfo);
    },
    // 校外成绩录入
    scoreAnalyze() {
      this.$emit("scoreAnalyze", true);
    },
    // 校外成绩录入
    externalScoreEntry() {
      this.$emit("externalScoreEntry", true);
    },
    // 科目分制录入
    pointSystemEntry() {
      this.$emit("pointSystemEntry", true);
    },
    // 科目分数指标录入
    scoreIndexEntry() {
      this.$emit("scoreIndexEntry", true);
    },
    // 删除年级考试
    deleteGradeClick() {
      this.$emit("deleteGradeClick");
    },
    // 创建考试
    createExam() {
      this.$emit("createExam", true);
    },
    // 修改考试
    editExam() {
      this.$emit("editExam", true);
    },
    // 成绩录入
    scoreEntry() {
      this.$emit("scoreEntry", true);
    },
    // 学生成绩对比
    gradeComparison() {
      this.$emit("gradeComparison", true);
    },
    // 校外成绩对比
    externalPerformanceComparison() {
      this.$emit("externalPerformanceComparison", true);
    },
    // 考试名次对比
    examRankComparison() {
      this.$emit("examRankComparison", true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./achievementTopBar.scss";
</style>
